<template>
	<popup ref="popup" :loading="popupLoading">
		<div slot="body">
			<el-form class="dataForm" ref="form" :disabled="disabled" :model="formParameter" :inline="true"
				label-width="80px">
				<el-row>
					<el-col :span="24">
						<b v-if="queType()">正确率：<i v-html="this.scorate"></i>%</b>
						<b v-else>得分率：<i v-html="this.scorate"></i>%</b>
						<el-card>
							<span style="color: #0c0">题目：<textarea cols="100" rows="3" disabled v-model="formParameter.title"></textarea> </span> 
								<br>
							<div v-for="(ch, idx2) in formParameter.choiceList">
								{{ ch.o }}.{{ ch.n }}
							</div><br>
							<div style="width: 50%">
								<span style="color: red;">标准答案： <span style="color: #777;font-size: 12px;"
										v-html="tbdata.answer"></span></span>
								<br><br>
								<span style="color: black;">题目解析:<span style="color: #777;font-size: 12px;"
										v-html="tbdata.analysis"></span></span>
								<br><br>
								<!-- 题目解析按钮 -->
								<el-button type="primary" v-if="!stuanswer" size="mini"
									@click="dialogVisible = true">更新答案-解析</el-button>
								<div v-else> {{ stuanswer.sn }} 于 {{ stuanswer.uptm }} 提交了待确认的新答案。</div>
							</div>
						</el-card>
					</el-col>
				</el-row>
			</el-form>
			<el-dialog title="提交更新答案-解析" :visible.sync="dialogVisible" width="30%" :append-to-body="true">
				新答案：<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入答案"
					v-model="myAnswer">
				</el-input>
				<br>

				新解析:<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="请输入解析"
					v-model="myAnyis">
				</el-input>
				<span slot="footer" class="dialog-footer">
					<el-button size="mini" @click="closeUpdate">取 消</el-button>
					<el-button size="mini" type="primary" @click="comfirmSub">确 定</el-button>
				</span>
			</el-dialog>
		</div>
		<div slot="footer">

			<el-button @click="close">关 闭</el-button>
		</div>
	</popup>
</template>

<script>
import popup from '@/components/popup/drawerPopup.vue';
import api from '@/api/exams/exams/rpt_answers.js';
import apiAnsr from "@/api/exams/exams/answers.js";

export default {
	name: 'edit',
	components: {
		popup
	},
	data() {
		return {
			disabled: false,
			popupLoading: false,
			confirmLoading: false,
			parameter: {},
			formParameter: {},

			tbdata: {},

			stu: {},

			scoreAll: 0,// 总得分
			scorate: 0,//正确率
			unScora: 0,//错误率
			dialogVisible: false,
			myAnswer: '',
			myAnyis: '',
			stuanswer: false
		};
	},
	methods: {
		//提交更新答案
		comfirmSub() {

			//取得自己
			let userInfo = this.$caches.user.get();

			let stuanswer = {
				sn: userInfo.name, uptm: new Date().format("yyyy-MM-dd"),
				ansr: this.myAnswer, anys: this.myAnyis
			};
			
		
			//提交学生答案更新
			apiAnsr.updateStuAnsr({ id: this.parameter.qid, stuanswer: JSON.stringify(stuanswer) }, res => {
				//刷新显示
				this.$utils.msg.success(res.msg);
				this.stuanswer =stuanswer
				this.closeUpdate()
			},err=>{this.$utils.msg.warning(res.msg);});

		},

		//点击取消清空我的答案
		closeUpdate() {
			this.dialogVisible = false;
			this.myAnswer = ''
			this.myAnyis = ''
		},
		queType() {
			if (this.parameter.type == '填空题' || this.parameter.type == '单选题' || this.parameter.type == '多选题' || this.parameter.type == '判断题') {
				return true;
			} else {
				return false;
			}
		},
		//打开弹框
		open(parameter, title, disabled, size) {
			this.parameter = parameter;
			this.stuanswer = false
			console.log("this.parameter", this.parameter)
			this.disabled = disabled;
			this.scorate = parameter.rrate
			this.$refs.popup.open(title, size);
			this.$nextTick(() => {
				this.init();
			})
		},
		//关闭弹框
		close() {
			this.disabled = false;
			this.$refs.popup.close();
		}, init() {
			this.popupLoading = true;
			//清除等待
			this.confirmLoading = false;
			//清空内容
			this.formParameter = {};

			this.stu = this.$caches.user.get();

			//清楚校验
			this.$refs.form.clearValidate();
			if (this.parameter.qid) {
				//编辑查询数据
			 
				api.getQueBiQid({sid:this.stu.id,     qid: this.parameter.qid }, response => {
					this.tbdata = response.data;
					console.log(this.tbdata);
					if (this.tbdata.stuanswer) {
						this.stuanswer = JSON.parse(this.tbdata.stuanswer)
					}
					this.formParameter = JSON.parse(this.tbdata.content);

					this.popupLoading = false;
				});
			} else {
				//添加
				this.popupLoading = false;
			}
		}
	}
};
</script>

<style lang="scss" scoped="scoped">@import '~common/custom/css/common.scss';
@import '~common/custom/css/popup/popup.scss';</style>
